// extracted by mini-css-extract-plugin
module.exports = {"quantity":"QuantitySelector_quantity__baPVZ","pdp-quantity":"QuantitySelector_pdp-quantity__sLnJv","qty-label-disabled":"QuantitySelector_qty-label-disabled__z7L8G"};